import { useEffect } from "react";
import { message } from "antd";
import { useSelector } from "react-redux";

export default function useDocDownloadError() {
  const { loading: docLoading, error: docError } = useSelector(
    (state) => state.documents,
  );

  useEffect(() => {
    if (docError) {
      message.error(docError || "Download failed");
    }
  }, [docError]);

  return docLoading;
}
